import {
    ICartItem,
} from '../interfaces';

export const CART_LOCAL_SYNC_GUARD_DURATION = 1500;

// Uses the most recent item timestamp as a simple freshness signal for cart snapshots.
export const getCartFreshnessScore = (cartItems: ICartItem[] | null | undefined): number => {
    if (!cartItems || cartItems.length === 0) return 0;
    return cartItems.reduce((score, item) => (
        Math.max(
            score,
            item.updated || item.timestamp || 0,
        )
    ), 0);
};

export const shouldBlockIncomingCartSnapshot = ({
    incomingCartItems,
    localFreshness,
    localGuardUntil,
    now = Date.now(),
}: {
    incomingCartItems: ICartItem[] | null | undefined,
    localFreshness: number,
    localGuardUntil: number,
    now?: number,
}): boolean => (
    // Ignore lagging server snapshots only while a short local-edit guard is active.
    now < localGuardUntil
    && getCartFreshnessScore(incomingCartItems) < localFreshness
);

export const getLocalCartSyncGuardState = (
    now = Date.now(),
    guardDuration = CART_LOCAL_SYNC_GUARD_DURATION,
): {
    localFreshness: number,
    localGuardUntil: number,
} => ({
    localFreshness: now,
    localGuardUntil: now + guardDuration,
});
